const CryptoJS = require('crypto-js');

function createState() {
    return CryptoJS.lib.WordArray.random(60).toString().slice(0, 128);
}

module.exports = {
    createState
};
